
import { Box, Typography, LinearProgress } from "@mui/material";

const EnergySavings = ({ saved, goal }: { saved: number; goal: number }) => {
  const percent = Math.min((saved / goal) * 100, 100);
  return (
    <Box textAlign="center" p={2}>
      <Typography variant="h6">Energy Savings</Typography>
      <Typography variant="body1" mb={1}>{saved} kWh saved</Typography>
      <LinearProgress variant="determinate" value={percent} sx={{ height: 10, borderRadius: 5 }} />
      <Typography variant="caption" mt={1}>{percent.toFixed(1)}% of {goal} kWh goal</Typography>
    </Box>
  );
};

export default EnergySavings;
